import data from "../../../../../src/Overlay/Overlay.docs.json";
import * as React from 'react';
export default {
  data,
  React
};